export default __webpack_public_path__ + "static/media/expert-career.09b4e22f.svg";